import { siteInfo, footerLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <a href="#hero" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-flower-line text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg text-background-50">{siteInfo.name}</span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {siteInfo.name}提供海量免费漫画，涵盖免费韩漫、免费日漫、免费国漫。随时随地免费看漫画，追更不花一分钱——让每一个漫迷都能在这里找到属于自己的漫画世界。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-50 mb-4">快速导航</h3>
            <div className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-50 mb-4">漫画分类</h3>
            <div className="grid grid-cols-2 gap-2">
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热血冒险</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">恋爱校园</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">奇幻魔法</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">科幻机甲</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">悬疑推理</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">古风仙侠</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">搞笑日常</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">美食生活</a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              合作伙伴区域，更多合作方信息敬请期待。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto max-w-[1200px] px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 {siteInfo.name} - 免费漫画在线阅读平台。本站所有漫画资源仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}